import React, { useState } from 'react';
import { Tabs } from 'antd';
import PageContainer from '@/components/PageContainer';
import DailyClearingTab from './DailyClearingTab';
import MonthlyClearingTab from './MonthlyClearingTab';
import MonthlySettlementTab from './MonthlySettlementTab';

const SettlementPage: React.FC = () => {
  const [activeMainTab, setActiveMainTab] = useState('daily');

  const mainTabs = [
    {
      key: 'daily',
      label: '日清分',
      children: <DailyClearingTab />,
    },
    {
      key: 'monthly-clear',
      label: '月清分',
      children: <MonthlyClearingTab />,
    },
    {
      key: 'monthly-settle',
      label: '月结算',
      children: <MonthlySettlementTab />,
    },
  ];

  return (
    <PageContainer title="结算单管理">
      <Tabs activeKey={activeMainTab} onChange={setActiveMainTab} items={mainTabs} />
    </PageContainer>
  );
};

export default SettlementPage;
